import styled from "styled-components";
import { Icon_CircleError } from "../common/CommonIcons";
import { useModalStore } from "src/stores/ModalStore";
import {CommonButton, NextButton } from "../common/CommonStyled";

const TitleWrapper = styled.div`
    display: flex;
    align-items: center;
    font-size: 18px;
    text-align: center;
    width: 100%;
    justify-content: center;
    font-weight: 600;
    gap: 12px;
`

const ContentWrapper = styled.div`
    margin-top: 16px;
    text-align: center;
    font-size: 14px;
    font-weight: 400;
`;

const ButtonWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;

    margin-top: 16px;
`

export const ModalTitleDelete = (
    <TitleWrapper>
        <Icon_CircleError/>
        정말 삭제하시겠어요?
    </TitleWrapper>
)

export const ModalContentDelete = (
    <ContentWrapper>
        홍보결과를 삭제하면 복구할 수 없습니다.
    </ContentWrapper>
)

export const ModalFooterDelete = ()=>{
    const modalSetField = useModalStore((state)=>state.setField)
    const acceptAction = useModalStore((state)=>state.acceptAction)

    return(
        <>
        <ButtonWrapper>
            <CommonButton style={{backgroundColor:'#E3E3E3', color:'black', minWidth:'96px', width:'96px', padding:'10px'}} onClick={()=>modalSetField('open',false)}>취소</CommonButton>
            <NextButton onClick={acceptAction} style={{color:'white'}}>삭제</NextButton>
        </ButtonWrapper>
        </>
    )
}